import { BadgeCheck, Crown } from "lucide-react";

export const ArtistBadge = ({ badge, size = 14 }) => {
  if (badge === "gold") return <Crown data-testid="badge-gold" size={size} className="text-amber-400 shrink-0" aria-label="Elite Gold badge" />;
  if (badge === "verified") return <BadgeCheck data-testid="badge-verified" size={size} className="text-sky-400 shrink-0" aria-label="Verified" />;
  return null;
};
